import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  date: string;
  isLast: boolean;
  onClick: (e: any) => void;
}

const Date = ({ date, isLast, onClick }: IProps) => (
  <>
    <em className={cx('Date')}>
      <button type="button" onClick={onClick}>
        {date}
      </button>
    </em>
    {!isLast && ' ~ '}
  </>
);

export default Date;
